import classNames from 'classnames';
import {
  useState,
} from 'react';
import { useSelector } from 'react-redux';
import {
  Navigate, useLocation,
  useNavigate,
} from 'react-router-dom';
import { Row, Col, Card } from 'reactstrap';

import { IRootState } from '@app/store';
import { CustomButton } from '@shared/buttons';
import { formatPhoneNumber } from '@shared/helpers';
import useTranslation from '@shared/hooks/useTranslation';
import { VerifiedIcon } from '@shared/icons';

import VerificationModal from './components/VerificationModal';
import './VerificationPage.scss';

const VerificationPage = () => {
  // const isLoggedIn = useSelector((state: IRootState) => !!state.Auth.accessToken);
  const isLoggedIn = useSelector(({ Auth }) => !!Auth.user.id);
  const userDetails = useSelector((state: IRootState) => state.Auth.user);
  const isEmailVerified = userDetails.is_email_verified;
  const isMobileVerified = userDetails.is_mobile_verified;
  const userEmail = userDetails?.email;
  const userMobile = userDetails?.mobile_number;
  const i18nVerification = useTranslation('verification.account');
  const [ modalVisible, setModalVisibility ] = useState(false);
  const [ verificationType, setVerificationType ] = useState('email');
  const navigate = useNavigate();
  const location = useLocation();

  const handleModalToggle = (type?: any) => {
    if (type === 'email' && isEmailVerified) return;
    if (type === 'mobile' && isMobileVerified) return;
    setVerificationType(type);
    setModalVisibility(prev => !prev);
  };

  const handleGoToHome = () => {
    navigate('/');
  };

  if (!isLoggedIn) {
    return <Navigate to="/auth/login" state={{ from: location }} />;
  }

  return (
    <div className="verification-page">
      <div className="d-flex flex-column align-items-center h-100" style={{ paddingTop: '10vh', paddingBottom: '15vh' }}>
        <Row>
          <Col>
            <div className="s1 title">
              {i18nVerification.title}
            </div>
          </Col>
        </Row>
        <Row className="mb-5">
          <Col>
            <div className="b1 mb-2">
              {i18nVerification.description1}
            </div>
            <div className="b1">
              {i18nVerification.description2}
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <Card
              className={classNames('verify-card-type', {
                verified: isEmailVerified,
              })}
              onClick={() => handleModalToggle('email')}
            >
              <div className="verify-card-title">
                {
                  !isEmailVerified ? i18nVerification.type.email.title
                    : i18nVerification.modal.verified.email.title
                }
              </div>
              <div className="verify-card-placeholder">
                <span style={{ marginRight: '5px' }}>
                  {isEmailVerified && (<VerifiedIcon />)}
                </span>
                <span className="verify-card-value">
                  {userEmail}
                </span>
              </div>
            </Card>
          </Col>
          <Col md={6}>
            <Card
              className={classNames('verify-card-type', {
                verified: isMobileVerified,
              })}
              onClick={() => handleModalToggle('mobile')}
            >
              <div className="verify-card-title">
                {
                  !isMobileVerified ? i18nVerification.type.mobile.title
                    : i18nVerification.modal.verified.mobile.title
                }
              </div>
              <div className="verify-card-placeholder">
                <span style={{ marginRight: '5px' }}>
                  {isMobileVerified && (<VerifiedIcon />)}
                </span>
                <span className="verify-card-value">
                  {formatPhoneNumber(userMobile)}
                </span>
              </div>
            </Card>
          </Col>
        </Row>
        <VerificationModal
          open={modalVisible}
          toggle={handleModalToggle}
          type={verificationType}
        />
        {
          isEmailVerified && isMobileVerified && (
            <div className="mt-5">
              <CustomButton
                id="btn-send"
                color="primary"
                className="btn-lg go-to-home-btn"
                onClick={handleGoToHome}
              >
                {i18nVerification.goToHome}
              </CustomButton>
            </div>
          )
        }
      </div>
    </div>
  );
};

export default VerificationPage;
